import { Footer } from "../components/Footer"
import { PayoutWalletMethods } from "../components/payout/PayoutWalletMethods"


export const PayoutWalletPage = () => {
    return (
        <div className="container">
            <PayoutWalletMethods />
            <Footer />
        </div>
    );
}